module.exports = __webpack_public_path__ + "img/dangericon.eade2845.svg";